import React from "react";
import { useIntl } from "react-intl";

import { TimePicker } from "../../DatePicker";

import { PRODUCTS } from "../../../utils/constants";
import { form } from "../../../messages";
import { format, parse } from "date-fns";

export default function EndHour({ values, handleChange }) {
  const intl = useIntl();

  const fixHour = (time) => {
    if (typeof time === "string") {
      const newDate = format(new Date(), "dd/MM/yyyy");
      const date = newDate + " " + time;
      return parse(date, "dd/MM/yyyy HH:mm", new Date());
    } else return time;
  };

  return (
    values.front_end_type === PRODUCTS.EVENT_PASS && (
      <TimePicker
        label={intl.formatMessage(form.endHour)}
        //value={values.end_hour}
        value={fixHour(values.end_hour)}
        onChange={handleChange("end_hour")}
        key="end_hour"
        fullWidth
        autoOk
        clearable
        required={!!values.start_hour}
      />
    )
  );
}
